// extracted by mini-css-extract-plugin
export default {"header_container":"Roles_header_container__bCVCD","header_text":"Roles_header_text__gQ8-C","table":"Roles_table__Q1y8o","thead":"Roles_thead__eMP5d","tr":"Roles_tr__dV6Sh"};